import { Injectable } from '@angular/core';
import { BaseTableService } from './base-table.service';
import { MOCEventCategory } from 'src/app/model/crm/moc-event-category';

@Injectable({
  providedIn: 'root',
})
export class MOCEventCategoryTableService extends BaseTableService<MOCEventCategory> {
  constructor() {
    super();
  }
}
